import { Box } from "@mui/material";
import { useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import FilterIcon from "../../assets/svg/filter-pack/filter.svg?react";
import CategoryTabs from "../../components/CategoryTabs";
import Filtered from "../../components/filtered";
import { EventPickerDialog } from "../../components/EventPickerDialog";
import { DateStrip } from "../../components/DateStrip";
import { CATEGORY_SHOULD_DISPLAYED } from "@/consts";
import useResize from "../../hooks/useResize";
import {
  btnCreateEventCont,
  btnsTabsCont,
  feedCont,
  fidContent,
  fidWrapper,
  filterForMapPage,
  filterIconCont,
  tabsContainer,
} from "./fidStyles";
import s from "./styles.module.css";
import EventProvider from "../../shared/events-feed/event-provider";
import PaginationView from "@components/PaginationView";
import CreateEventButton from "@components/CreateEventButton";
import { useAppDispatch, useAppSelector } from "@app/hooks";
import { toggleGridView, selectGridView } from "@shared/gridView/gridViewSlice";
import { updateFreeArgs } from "@shared/filter/filterSlice";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const isActiveButton = (v: { isActive: boolean }) =>
  v.isActive ? `${s.button_feed} ${s.active}` : s.button_feed;

const Fid = () => {
  const { pathname } = useLocation();
  const screenWidth = useResize();
  const [isFilterShow, setIsFilterShow] = useState(false);
  const isDesktopMap = (): boolean => pathname === "/map" && screenWidth >= 1033;
  const dispatch = useAppDispatch();
  const gridView = useAppSelector(selectGridView);
  const isFree = useAppSelector((state) => state.filter.isFree);

  const handleFreeToggle = () => {
    dispatch(updateFreeArgs(isFree ? undefined : true));
  };

  return (
    <div style={fidWrapper}>
      <div style={fidContent}>
        {CATEGORY_SHOULD_DISPLAYED.includes(pathname) && <CategoryTabs />}

        {/* Полоска дат — показываем везде включая карту */}
        <DateStrip />

        <Box sx={feedCont}>
          <Box sx={btnsTabsCont}>
            <Box sx={tabsContainer}>
              <NavLink to={"/"} className={isActiveButton}>
                Лента
              </NavLink>
              <NavLink to={"/map"} className={isActiveButton}>
                На карте
              </NavLink>
              <button
                onClick={handleFreeToggle}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "4px 10px",
                  borderRadius: "20px",
                  border: isFree ? "1.5px solid #4CAF50" : "1.5px solid var(--borders)",
                  background: isFree ? "rgba(76,175,80,0.12)" : "transparent",
                  color: isFree ? "#4CAF50" : "var(--secondary-text)",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: isFree ? 600 : 400,
                  whiteSpace: "nowrap",
                  transition: "all 0.2s",
                }}
              >
                <AccountBalanceWalletIcon style={{ fontSize: "15px" }} />
                &nbsp;0 ₽
              </button>
            </Box>
          </Box>

          <Box sx={btnCreateEventCont}>
            {/* Кнопка переключения вида сетки — только на мобиле и только в ленте */}
            {pathname === "/" && (
              <Box
                onClick={() => dispatch(toggleGridView())}
                sx={{
                  ...filterIconCont,
                  background: gridView === 'double' ? "var(--btns-selected)" : "transparent",
                  cursor: "pointer",
                  marginRight: "4px",
                }}
              >
                {gridView === 'single' ? (
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="var(--secondary-text)" strokeWidth="1.5" strokeLinecap="round">
                    <rect x="1" y="1" width="7" height="7" rx="1.5"/>
                    <rect x="10" y="1" width="7" height="7" rx="1.5"/>
                    <rect x="1" y="10" width="7" height="7" rx="1.5"/>
                    <rect x="10" y="10" width="7" height="7" rx="1.5"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="var(--secondary-text)" strokeWidth="1.5" strokeLinecap="round">
                    <rect x="1" y="1" width="16" height="7" rx="1.5"/>
                    <rect x="1" y="10" width="16" height="7" rx="1.5"/>
                  </svg>
                )}
              </Box>
            )}

            {pathname !== "/map" || (screenWidth >= 768 && screenWidth <= 1033) ? (
              <Box
                onClick={() => setIsFilterShow((prev) => !prev)}
                sx={{
                  ...filterIconCont,
                  background: isFilterShow
                    ? "var(--btns-selected)"
                    : "transparent",
                  cursor: "pointer",
                }}
              >
                <FilterIcon
                  stroke={`var(--secondary-text)`}
                  style={{ position: "absolute" }}
                />
              </Box>
            ) : null}

            {isDesktopMap() && <CreateEventButton />}
            {pathname !== "/map" && screenWidth >= 768 && <CreateEventButton />}
          </Box>
        </Box>

        <EventProvider>
          <Box sx={{ ...feedCont, paddingTop: "0 !important" }}>
            {isFilterShow && (
              <Filtered
                isOpenFilter={isFilterShow}
                setIsOpenFilter={setIsFilterShow}
                extraStyles={{
                  ...filterForMapPage,
                  right: 25,
                  zIndex: 100,
                }}
              />
            )}
            <Outlet context={{ gridView }} />
          </Box>
        </EventProvider>
        <PaginationView />
      </div>

      <EventPickerDialog />
    </div>
  );
};

export default Fid;
